module.exports = __webpack_public_path__ + "img/icon-success.855f55ed.svg";